import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const state = () => ({
  loginHeader: false,
});

// getters
const getters = {
  getLoginHeader: (state) => state.loginHeader,
};

//actions
const actions = {};

// mutations
const mutations = {
  SET_LOGIN_HEADER(state, loginHeader) {
    state.loginHeader = loginHeader;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
